import { useEffect, useRef, useState } from "react";
import useWindowSize from "../../hooks/useWindowSize";
import { CarouselProvider, Slide, Slider } from "pure-react-carousel";
import { RoundBluePlain, RoundGreyPlain } from "../ui/Buttons/generic/GenericButton";

const ActionSlider= ()=> {

    const spaceBetweenSlides= 25;
    const windowWidth= useWindowSize();
    const [carouselContainerSize, setCarouselContainerSize]= useState(windowWidth * 90 / 100);//<- the container is actually 90% of the window at this point <- why did I not think about it earlier ??? <- this is why I struggled so much with the first slider :D
    
    const carouselContainerRef= useRef<HTMLDivElement>(null);
    const slideRef= useRef<HTMLDivElement>(null);
    const [slideSizesInX, setSlideSizeInX]= useState(431);

    const [slidesToShow, setSlidesToShow]= useState(2);

    //All this mess is to compute the with of the slides and their spacing
    //to make the slider responsive and avoid having it break when the screen resizes.
    //I used the same logic for other sliders. Too lazy to make it a separate component.
    //Don't worry about it too much unless you absolutely have to.
    useEffect(()=>{
        const windowResizeHandler= ()=> {
            if(carouselContainerRef.current){
                setCarouselContainerSize(carouselContainerRef.current.offsetWidth);
            }
            if(slideRef.current){
                setSlideSizeInX(slideRef.current.offsetWidth);
            }
        }
        window.addEventListener("resize", windowResizeHandler);
        window.dispatchEvent(new Event("resize")); //<- It is required
        return ()=>{
            window.removeEventListener("resize", windowResizeHandler);
        };
    }, []);

    useEffect(()=>{
        if(carouselContainerRef.current && slideRef.current){
            setSlidesToShow(((carouselContainerSize + spaceBetweenSlides) / (slideRef.current.offsetWidth + spaceBetweenSlides))*95/100);
        } else {
            setSlidesToShow(((windowWidth + spaceBetweenSlides) / (slideSizesInX + spaceBetweenSlides))*95/100);
        }

    }, [carouselContainerSize, windowWidth]);


    return (<>
        <div className="w-full py-[9rem] overflow-hidden">
            <div className="lg:w-4/5 lg:min-w-[900px] w-[94%] mx-auto no-clip-slider" ref={carouselContainerRef}>
                <CarouselProvider naturalSlideHeight={470} naturalSlideWidth={285} visibleSlides={slidesToShow} totalSlides={2} isIntrinsicHeight={true}>
                    <Slider>
                        <Slide index={1} key={1} >
                            <div className={"bg-primary-blue rounded-[2.5rem] md:py-[4rem] md:px-[3rem] px-[1.2rem] py-[1.5rem] sm:w-[431px] w-[88vw] flex flex-col gap-4 max-w-[553px]"} ref={slideRef}>
                                <div className="w-full h-[13rem] overflow-hidden rounded-2xl bg-cover bg-center bg-norepeat" style={{backgroundImage: `url('/about-images/about-03.webp')`}}>
                                </div>
                                <div className="w-full flex flex-col gap-3">
                                    <div className="text-transparent bg-clip-text bg-gradient-to-r from-purple-500 via-pink-500 to-orange-500 text-3xl font-semibold">Vous êtes une entreprise ?</div>
                                    <h2 className="md:text-4xl text-3xl text-white font-semibold fade-in">Confiez votre projet à Wall of Share !</h2>
                                    <p className="text-[#BBBBC4cc] font-medium md:text-xl text-[16px] leading-[19px] font-dm-sans fade-in">Avec Wall of Share, rencontrez le talent qui correspond exactement à votre besoin. Simplifiez votre processus de recrutement et accédez rapidement à des experts prêts à relever vos défis.</p>
                                </div>
                                <RoundBluePlain text="Inscrivez-vous" isButton={false} to={"/inscription-entreprises"} className="px-[2rem] py-[1rem] font-semibold fade-in" />
                            </div>
                        </Slide>
                        <Slide index={2} key={2} >
                            <div className={"bg-[#F4F4F5] rounded-[2.5rem] md:py-[4rem] md:px-[3rem] px-[1.2rem] py-[1.5rem] sm:w-[431px] w-[88vw] flex flex-col gap-4 max-w-[553px]"}>
                                <div className="w-full h-[13rem] overflow-hidden rounded-2xl bg-cover bg-center bg-norepeat" style={{backgroundImage: `url('/acceuil-images/action-02.webp')`}}>
                                </div>
                                <div className="w-full flex flex-col gap-3">
                                    <div className="text-transparent bg-clip-text bg-gradient-to-r from-purple-500 via-pink-500 to-orange-500 text-3xl font-semibold">Vous êtes un freelance ?</div>
                                    <h2 className="md:text-4xl text-3xl text-primary-blue font-semibold fade-in">Mettez en valeur vos
                                    compétences !</h2>
                                    <p className="text-[#6F6F6F] font-medium md:text-xl text-[16px] leading-[19px] font-dm-sans fade-in">Rejoignez une communauté d'experts et accédez à des projets qui correspondent à vos compétences. Avec Wall of Share, valorisez votre expertise et trouvez des missions qui vous stimulent.</p>
                                </div>
                                <RoundGreyPlain text="Inscrivez-vous" isButton={false} to={"/inscription-freelances"} className="px-[2rem] py-[1rem] font-semibold fade-in" />
                            </div>
                        </Slide>
                    </Slider>
                </CarouselProvider>
            </div>
        </div>
    </>);
};

export default ActionSlider;